import { ConvexReactClient } from "convex/react";

const url = process.env.BUN_PUBLIC_CONVEX_URL;

if (!url) {
  throw new Error(
    "BUN_PUBLIC_CONVEX_URL is not set. Run `npx convex dev` and ensure it is exported in .env.local",
  );
}

export const convex = new ConvexReactClient(url);
